import get from 'lodash.get';

const getCurrentState = path => {
    try {
        const data = JSON.parse(localStorage.getItem('__STATE_MACHINE__'));

        return path ? get(data, path) : data;
    } catch (e) {
        console.warn(`State query for ${path} failed`);
        return '';
    }
};

export {getCurrentState};
